<template>
    <div>
    <!-- 移动端卡片模式 -->
    <div v-if="cardMode" class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
        <div class="card-body p-4">
            <div @click="settingCheckBox = true" class="flex items-center justify-between cursor-pointer">
                <div class="flex items-center space-x-3">
                    <div class="p-2 bg-secondary/10 rounded-lg">
                        <svg-icon name="settings" class="w-6 h-6 fill-secondary" />
                    </div>
                    <div>
                        <div class="font-medium text-base-content">配置设置</div>
                        <div class="text-sm text-base-content/70">详情显示和字段配置</div>
                    </div>
                </div>
                <div class="flex-shrink-0">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                    </svg>
                </div>
            </div>
        </div>
    </div>

    <!-- 桌面端原有模式 -->
    <div v-else :class="['flex', 'flex-col', detail ? 'w-48 items-start' : 'w-32 items-center']">
        <!-- 配置设置 -->
        <div class="mt-2">
            <div>
                <button @click="settingCheckBox = true"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                    data-tip="配置">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                        <svg-icon name="settings" class="w-16 h-6 fill-current" />
                        <div v-if="detail" class="mr-auto">配置</div>
                    </span>
                </button>
            </div>
        </div>
    </div>

    <!-- 通用 Drawer (移动端和桌面端共用) -->
    <div class="drawer">
        <input id="batch-settings" type="checkbox" class="drawer-toggle" v-model="settingCheckBox" />
        <div class="drawer-side">
            <div @click="settingCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>
            <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                <div class="flex justify-between items-center mb-4">
                    <div class="text-xl font-medium">详情显示设置</div>
                    <div>
                        <button class="btn btn-sm btn-neutral" @click="handleBatchSettings">确认</button>
                        <button class="btn btn-sm ml-1" @click="settingCheckBox = false">取消</button>
                    </div>
                </div>
                <div>
                    <div class="">media目录:</div>
                    <div class="form-control">
                        <label class="label cursor-pointer">
                            <span class="label-text">开启详情页</span>
                            <input type="checkbox" class="toggle toggle-primary"
                                v-model="batchSettingFormData.isOpenDetail" />
                        </label>
                    </div>
                    <div class="form-control">
                        <label class="label cursor-pointer">
                            <span class="label-text">开启深度遍历</span>
                            <input type="checkbox" class="toggle toggle-primary"
                                v-model="batchSettingFormData.isDepth" />
                        </label>
                        <div class="text-gray-400 text-sm">会显示子文件夹下的文件信息</div>
                    </div>
                    <div class="mt-2">webdav目录:</div>
                    <div class="form-control">
                        <label class="label cursor-pointer">
                            <span class="label-text">开启详情页</span>
                            <input type="checkbox" class="toggle toggle-primary"
                                v-model="batchSettingFormData.isOpenWebdav" />
                        </label>
                    </div>
                    <div class="form-control">
                        <label class="label cursor-pointer">
                            <span class="label-text">开启深度遍历</span>
                            <input type="checkbox" class="toggle toggle-primary"
                                v-model="batchSettingFormData.isDepthWebdav" />
                        </label>
                        <div class="text-gray-400 text-sm">小心开启会大量访问网盘</div>
                    </div>
                    <div class="form-control mt-2">
                        <label class="label cursor-pointer">
                            <span class="label-text">限制条数</span>
                            <input type="number" placeholder="请输入"
                                class="input input-bordered input-sm max-w-xs"
                                v-model="batchSettingFormData.limit" />
                        </label>
                        <div class="text-gray-400 text-sm">显示详情列表的条数,避免卡住页面</div>
                    </div>
                    <div class="form-control">
                        <label class="label cursor-pointer">
                            <span class="label-text">显示字段</span>
                        </label>
                        <multi-select :options="fieldListID3" v-model="showFieldsID3"></multi-select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import MultiSelect from "@/components/iview/MultiSelect";
import SvgIcon from '@/components/SvgIcon.vue'
export default {
    name: 'BatchSettings',
    components: { MultiSelect, SvgIcon },
    props: {
        detail: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        cardMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            settingCheckBox: false,
            batchSettingFormData: {
                'isOpenDetail': localStorage.getItem('isOpenDetail') !== 'false',
                'isDepth': localStorage.getItem('isDepth') === 'true',
                'isOpenWebdav': localStorage.getItem('isOpenWebdav') === 'true',
                'isDepthWebdav': localStorage.getItem('isDepthWebdav') === 'true',
                'limit': localStorage.getItem('limit') ? localStorage.getItem('limit') : 30
            },
            showFieldsID3: localStorage.getItem('showFieldsID3') ? JSON.parse(localStorage.getItem('showFieldsID3')) : ['album_img', 'filename', 'title', 'artist', 'album', 'albumartist', 'lyrics', 'lyrics_file', 'year', 'genre'],
            fieldListID3: [
                { id: 'checkbox', name: '勾选' },
                { id: 'album_img', name: '专辑封面' },
                { id: 'title', name: '标题' },
                { id: 'filename', name: '文件名' },
                { id: 'artist', name: '艺术家' },
                { id: 'album', name: '专辑' },
                { id: 'album_type', name: '专辑类型' },
                { id: 'albumartist', name: '专辑艺术家' },
                { id: 'discnumber', name: '光盘编号' },
                { id: 'tracknumber', name: '音轨号' },
                { id: 'totaltracks', name: '总音轨数' },
                { id: 'totaldiscs', name: '总光盘数' },
                { id: 'genre', name: '风格' },
                { id: 'year', name: '年份' },
                { id: 'lyrics', name: '歌词' },
                { id: 'lyrics_file', name: '歌词(LRC文件)' },
                { id: 'comment', name: '简介' },
                { id: 'description', name: '描述' },
                { id: 'duration', name: '时长' },
                { id: 'size', name: '文件大小' },
                { id: 'bit_rate', name: '比特率' },
                { id: 'sample_rate', name: '采样率' },
                { id: 'channels', name: '声道' },
                { id: 'bit_depth', name: '位深度' },
                { id: 'language', name: '语言' },
                { id: 'composer', name: '作曲家' },
                { id: 'lyricist', name: '作词家' },
                { id: 'replaygain_track_gain', name: '曲目增益' },
                { id: 'replaygain_track_peak', name: '曲目峰值' },
                { id: 'replaygain_album_gain', name: '专辑增益' },
                { id: 'replaygain_album_peak', name: '专辑峰值' }
            ]
        }
    },
    methods: {
        handleBatchSettings() {
            window.localStorage.setItem('isOpenDetail', this.batchSettingFormData.isOpenDetail)
            window.localStorage.setItem('isDepth', this.batchSettingFormData.isDepth)
            window.localStorage.setItem('isOpenWebdav', this.batchSettingFormData.isOpenWebdav)
            window.localStorage.setItem('isDepthWebdav', this.batchSettingFormData.isDepthWebdav)
            window.localStorage.setItem('limit', this.batchSettingFormData.limit)
            const obj = JSON.stringify(this.showFieldsID3)
            window.localStorage.setItem('showFieldsID3', obj)
            this.settingCheckBox = false
            this.$emit('settings-saved');
        },
        handleSetDetail() {
            this.$emit('update:detail', !this.detail);
        }
    }
}
</script>

<style scoped>
.icon {
    @apply fill-current w-16;
}
</style>